import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

// components
import { AnalyticsProps } from '@inplayer-org/inplayer-ui';
import { PreviewBox, Image, Title, Button, Description } from './StyledElements';

const StyledPreviewBox = styled(PreviewBox)`
  width: 56%;
  padding: 10px 5.2%;
  text-align: center;
`;

const StyledImage = styled(Image)`
  width: 50%;
  padding-bottom: 50%;
  border-radius: 50%;
`;

const StyledTitle = styled(Title)`
  display: inline-block;
`;

const StyledButton = styled(Button)`
  display: inline-block;
`;

interface OwnProps extends AnalyticsProps {
  id: number;
  onBodyClick: (id: number) => void;
  isTemplateSelected: boolean;
}

const PreviewTemplate7: FunctionComponent<OwnProps> = ({ id, onBodyClick, isTemplateSelected }) => {
  const onClick = () => onBodyClick(id);

  return (
    <StyledPreviewBox onClick={onClick} isTemplateSelected={isTemplateSelected}>
      <StyledImage isTemplateSelected={isTemplateSelected} />
      <StyledTitle />
      <Description />
      <Description />
      <Description />
      <StyledButton isTemplateSelected={isTemplateSelected} />
    </StyledPreviewBox>
  );
};

export default PreviewTemplate7;
